import { showNotification } from "@/entities/notification"
import { registerNotification } from "@/shared/api/websocket"
import { easyMatchKeys } from "../model/keys"

registerNotification("new_spins", {
	handle: ({ notification_id }, ctx) => {
		showNotification({
			type: "silent",
			placement: null,
			origin: "server",
			notificationId: notification_id,
			name: "new_spins",
		})
		ctx.queryClient.invalidateQueries({
			queryKey: easyMatchKeys.status(ctx.userId),
		})
	},
	route: () => ({ to: "/home" }),
	routePopup: null,
})
